import { getRetailer } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getRetailer";

interface IMessengerCapabilities {
  canStartConversation: boolean;
}

/**
 * Checks messenger capabilities for the current retailer.
 */
export const useMessengerCapabilities = (): IMessengerCapabilities => {
  const retailer = getRetailer();

  return {
    canStartConversation: retailer?.identity_confirmed ?? false,
  };
};
